import { render, staticRenderFns } from "./Magazines.vue?vue&type=template&id=1a181a38"
import script from "./Magazines.vue?vue&type=script&lang=js"
export * from "./Magazines.vue?vue&type=script&lang=js"
import style0 from "./Magazines.vue?vue&type=style&index=0&id=1a181a38&prod&lang=css"
import style1 from "./Magazines.vue?vue&type=style&index=1&id=1a181a38&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports